import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';

export interface RedirectResult {
  shortUrl: string;
  longUrl: string;
  rowKey: string;
  redirectUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  
  private apiBaseUrl = 'https://apihelper.azurewebsites.net/api'; // Reemplaza con tu URL real

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  private longURL$ = new BehaviorSubject<any>(null);
  public longURL: Observable<any> = this.longURL$.asObservable();

  async getLongUrl(shortCode: string, medium: string = 'web'): Promise<string | null> {
    try {
      if (!isPlatformBrowser(this.platformId)) {
        return null;
      }

      const requestBody = {};

      const response = await this.http.post<RedirectResult>(
        `${this.apiBaseUrl}/GetLongUrl?ShortUrl=${shortCode}`, 
        requestBody
      ).toPromise();

      if (response && response.redirectUrl) {
        this.longURL$.next(response.redirectUrl);
        return response.redirectUrl;
      }

      return null;
    } catch (error) {
      console.error('Error obteniendo URL larga:', error);
      return null;
    }
  }

  async logRedirectData(data: any): Promise<void> {
    try {
      await this.http.post(`${this.apiBaseUrl}/LogRedirect`, data).toPromise();
    } catch (error) {
      console.error('Error registrando datos de redirect:', error);
    }
  }

  async getLongURL() {
    return this.longURL$.getValue();
  }
}
